import i18n from '@/libs/i18n'

const LOCALE_MAP = {
  pt: 'pt-BR',
  en: 'en-US',
  es: 'es-ES',
}

export function getIntlLocale() {
  return LOCALE_MAP[i18n.locale] || LOCALE_MAP.en
}
